import API from "Connectors/_main";

export const getMaintenanceBreakData = () => {
  return API.get<any>('/maintenance-break')
}



// WEBPACK FOOTER //
// ./src/API/maintenance-break-resource/MaintenanceBreak.Connector.ts